import axios from 'axios'
import router from './../../router'
import decode from 'jwt-decode'

const state = {
  token: null,
  credencialesLogin:null,
  clientesConsult : null,
};

const mutations = {
  setToken(state, token) {
    state.token = token

    if (token) {
      localStorage.setItem('token', token)
    } else {
      localStorage.removeItem('token')
    }
  },
  setCredencialesLogin(state,credenciales){
    state.credencialesLogin = credenciales
  },
  setClientes(state, clientes){
    //console.log(clientes)
    state.clientesConsult = clientes
  }
};

const actions = {
  autoLogin({
    commit,
    dispatch,
    rootGetters
  }) {
    const token = localStorage.getItem('token');
    
    if (!token) {
      return
    }
    commit('setToken', token);
    
    if (rootGetters.idCliente) {
      dispatch('consultarClienteExistente')
      dispatch('consultarCliente')
      
    }
  },

  registrarUsuario({
    commit,
    dispatch /*, rootGetters*/
  }, registro) {
    commit('mostrarOcupado', 'Validando Registro...')
    axios.post('/api/account/RegisterCentralYMolinos', {
      email: registro.email,
      documento: registro.documento,
      idTipoDocumento : registro.idTipoDocumento
    })
      .then(() => {
        dispatch('mostrarMensaje', {
          imagen: 'email',
          titulo: 'Validar Email',
          contenido: 'Te hemos enviado un correo a <b>' + registro.email + '</b>. Ingresa a tu cuenta de correo y haz clic en el botón <b>Confirmar Email</b>. Una vez se valide tu correo podrás continuar con el registro.'
        })
        commit('ocultarOcupado')
      })
      .catch(error => {
        if (error.response.data.code == 'DuplicateUserName') {
          dispatch('mostrarMensaje', {
            imagen: 'emo-thinking',
            titulo: 'El email ya está en uso',
            contenido: 'El email <b>' + registro.email + '</b> ya ha sido registrado.',
            enlace1: {
              ruta: {
                name: 'login'
              },
              etiqueta: 'Si ya te has registrado ingresa aquí.'
            },
            enlace2: {
              ruta: {
                name: 'register'
              },
              etiqueta: 'O regístrate con otro usuario aquí.'
            }
          })
        } else {
          dispatch('mostrarMensaje', {
            imagen: 'emo-sad',
            titulo: 'Error Creando el Registro',
            contenido: 'Se presentaron problemas al intentar crear el registro.',
            boton: {
              ruta: {
                name: 'register'
              },
              etiqueta: 'Intenta el registro nuevamente'
            }
          })
        }
        commit('ocultarOcupado')
      })
      .catch(() => {
        dispatch('mostrarMensaje', {
          imagen: 'emo-sad',
          titulo: 'Error Creando el Registro',
          contenido: 'Se presentaron problemas al intentar crear el registro.',
          boton: {
            ruta: {
              name: 'register'
            },
            etiqueta: 'Intenta el registro nuevamente'
          }
        })
        commit('ocultarOcupado')
      })
  },
   consultarClienteExistente({commit}, userId){
    commit('ocultarOcupado')
     //console.log("Enviando el user Id", userId)
      axios.post('/api/cliente/consultarCliente', {
       userId: this.getters.userId
     })
     .then(res => {
       let clienteRegistrado = res.data
       //console.log(clienteRegistrado)
       commit('setClientes', clienteRegistrado)
     })
     .catch((error)=>{
       console.log(error)
    })
  },
  confirmarEmail({
    commit,
    dispatch
  }, data) {
    commit('mostrarOcupado', 'Validando Email...')
    axios.post('/api/account/ConfirmEmail', {
      userId: data.userId,
      code: data.code
    })
      .then(res => {
        commit('setToken', res.data.result)
        router.push({
          name: 'completar-registro'
        })
        commit('ocultarOcupado')
      })
      .catch(() => {
        dispatch('mostrarMensaje', {
          imagen: 'emo-sad',
          titulo: 'Error Validando el Email',
          contenido: 'Ocurrió un error validando el código de activación. Intenta volver a acceder desde tu correo haciendo clic en el código enviado',
          boton: {
            ruta: {
              name: 'reenviar-codigo'
            },
            etiqueta: 'Reenviarme Código'
          }
        })
        commit('ocultarOcupado')
      })
  },

  reenviarCodigo({
    commit,
    dispatch
  }, email) {
    commit('mostrarOcupado', 'Reenviando código de verificación...')
    axios.post('/api/account/ResendCode', {
      email: email
    })
      .then(() => {
        dispatch('mostrarMensaje', {
          imagen: 'email',
          titulo: 'Validar Email',
          contenido: 'Te hemos enviado un correo a <b>' + email + '</b>. Ingresa a tu cuenta de correo y haz clic en el botón <b>Confirmar Email</b>. Una vez se valide tu correo podrás continuar con el registro.',
        })
        commit('ocultarOcupado')
      })
      .catch(error => {
        if (error.response && error.response.data && error.response.data.code) {
          if (error.response.data.code == 'NotFound') {
            dispatch('mostrarMensaje', {
              imagen: 'emo-thinking',
              titulo: 'Email No Encontrado',
              contenido: 'Debes registrarte primero con el email especificado.',
              boton: {
                ruta: {
                  name: 'register'
                },
                etiqueta: 'Ir a Registro'
              }
            })
          } else if (error.response.data.code == 'EmailConfirmed') {
            dispatch('mostrarMensaje', {
              imagen: 'emo-happy',
              titulo: 'Email ya Validado',
              contenido: 'Parece que tu cuenta ya ha sido validada. Ve al módulo de login para continuar.',
              boton: {
                ruta: {
                  name: 'login'
                },
                etiqueta: 'Ir a Login'
              }
            })
          }
        } else {
          dispatch('mostrarMensaje', {
            imagen: 'emo-sad',
            titulo: 'Error Enviando Código',
            contenido: 'Ocurrió un error intentando enviar el código. Revisa que el email ingresado sea válido y vuelve a intentarlo.',
            boton: {
              ruta: {
                name: 'reenviar-codigo'
              },
              etiqueta: 'Intentar Nuevamente'
            }
          })
        }
        commit('ocultarOcupado')
      })
  },

  forgotPassword({
    commit,
    dispatch
  }, email) {
    commit('mostrarOcupado', 'Enviando Solicitud...')
    axios.post('/api/account/ForgotPassword', {
      email: email
    })
      .then(() => {
        dispatch('mostrarMensaje', {
          imagen: 'email',
          titulo: 'Restablecer Contraseña',
          contenido: 'Te hemos enviado un correo a <b>' + email + '</b>. Ingresa a tu cuenta de correo y haz clic en el enlace para ingresar una nueva contraseña.',
        })
        commit('ocultarOcupado')
      })
      .catch(() => {
        dispatch('mostrarMensaje', {
          imagen: 'emo-sad',
          titulo: 'Error Enviando el Email',
          contenido: 'Ocurrió un error enviando el email para restablecer tu contraseña. Inténtalo más tarde.'
        })

        commit('ocultarOcupado')
      })
  },

  resetPassword({
    commit,
    dispatch
  }, data) {
    commit('mostrarOcupado', 'Validando Datos...')
    axios.post('/api/account/ResetPassword', data)
      .then(() => {
        dispatch('mostrarMensaje', {
          imagen: 'emo-happy',
          titulo: 'Contraseña Restablecida',
          contenido: 'Ya puedes volver a ingresar con el email y la contraseña especificados.',
          boton: {
            ruta: {
              name: 'login'
            },
            etiqueta: 'Ir a Login'
          }
        })
        commit('ocultarOcupado')
      })
      .catch(() => {
        dispatch('mostrarMensaje', {
          imagen: 'emo-sad',
          titulo: 'Error Validando los Datos',
          contenido: 'Ocurrió un error validando los datos ingresados.'
        })

        commit('ocultarOcupado')
      })
  },

  externalLoginFacebook({
    commit,
    dispatch
  }, accessToken) {
    commit('mostrarOcupado', 'Validando autenticación...')
    axios.post('/api/account/ExternalLoginFacebook', {
      accessToken
    })
      .then(res => {
        if (res.data && res.data.result) {
          commit('setToken', res.data.result)
          dispatch('consultarCliente')
        } else {
          router.push({
            name: 'confirmar-email-externo',
            params: {
              email: res.data.email,
              accessToken: res.data.accessToken
            }
          })
        }
        commit('ocultarOcupado')
      })
      .catch(() => {
        dispatch('mostrarMensajeErrorFacebook')
        commit('ocultarOcupado')
      })
  },

  confirmarEmailExterno({
    commit,
    dispatch
  }, data) {
    commit('mostrarOcupado', 'Validando autenticación...')
    axios.post('/api/account/ExternalLoginConfirmationFacebook', {
      email: data.email,
      accessToken: data.accessToken
    })
      .then(res => {
        commit('setToken', res.data.result)
        router.push({
          name: 'completar-registro'
        })
        commit('ocultarOcupado')
      })
      .catch(() => {
        dispatch('mostrarMensajeErrorFacebook')
        commit('ocultarOcupado')
      })
  },



  async login({commit,dispatch,/*rootGetters*/}, ingreso) {
    commit('mostrarOcupado', 'Validando autenticación...')
    await axios.post('api/account/Login', {
      email: ingreso.email,
      documento: ingreso.documento,
      idTipoDocumento: ingreso.idTipoDocumento
    })
    .then((res)=>{
      commit('setToken', res.data);
      commit('setCredencialesLogin',ingreso)
      commit('ocultarOcupado');
      dispatch('consultarCliente');
    })
    .catch(function(error){
      dispatch('mostrarMensaje', {
        imagen: 'emo-sad',
        titulo: 'No fue posible validar tus datos',
        contenido: 'Revisa que el email y contraseña especificados sean correctos.',
        boton: {
          ruta: {
            name: 'login'
          },
          etiqueta: 'Volver a intentar'
        }
      });
      commit('ocultarOcupado');
    })
  },

  logout({
    commit
  }) {
    commit('setToken', null)
    commit('resetCliente')
    commit('resetPuntajeActual')
    commit('resetPuntajeAnimado')
    router.push({
      name: 'login'
    })
  },

  mostrarMensajeErrorFacebook({
    dispatch
  }) {
    dispatch('mostrarMensaje', {
      imagen: 'emo-sad',
      titulo: 'No fue posible ingresar con Facebook',
      contenido: 'No fue posible ingresar con tu cuenta de Facebook, intenta nuevamente.',
      boton: {
        ruta: {
          name: 'facebook-login-url'
        },
        etiqueta: 'Reintentar'
      },
      enlace1: {
        ruta: {
          name: 'login'
        },
        etiqueta: 'Si ya te has registrado ingresa aquí.'
      },
      enlace2: {
        ruta: {
          name: 'register'
        },
        etiqueta: 'O regístrate con otro método aquí.'
      }
    })
  }
};

const getters = {
  token(state) {
    return state.token;
  },
  userId(state) {
    if (state.token) {
      let user = decode(state.token)

      if (user && user.userId) {
        return user.userId
      }
    }

    return undefined
  },
  credencialesLogin(state){
    return state.credencialesLogin
  },
  userName(state) {
    if (state.token) {
      let user = decode(state.token)

      if (user && user.sub) {
        return user.sub
      }
    }

    return undefined
  },
  clienteConsult(state){
    let info = state.clientesConsult
    return info
  },
  nombre1(state) {
    if (state.token) {
      let user = decode(state.token)

      if (user && user.nombre1) {
        return user.nombre1
      }
    }

    return undefined
  },
  emailDuplicado(state) {
    return state.emailDuplicado;
  },
  datosCompletarRegistro(state) {
    if (state.token) {
      let user = decode(state.token)
      if (user.sexo) {
        return {
          sexo: user.sexo,
          nombre1: user.nombre1,
          nombre2: user.nombre2,
          apellido1: user.apellido1,
          apellido2: user.apellido2
        }
      }
    }

    return null
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};